import { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Box,
  Stack,
  DialogTitle
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { PowerBIEmbed } from 'powerbi-client-react';

import {
  getPbiUrlConfigsForSkuDetails,
  getReportIdForGen2,
  getDatasetId,
  getEmbedConfig
} from '../PortfolioDetailView/PBIReports';
import { fetchPBIEmbedToken } from '../PortfolioDetailView/services';

import '../PortfolioDetailView/iframe.css';

const SkuDetails = ({selectedBu}) => {
  const [openIframe, setOpenIframe] = useState(false);
  const [pbiEmbedToken, setPbiEmbedToken] = useState('');
  const [selectedUrl, setSelectedUrl] = useState('');
  const reportId = getReportIdForGen2();

  useEffect(() => {
    if(openIframe) {
      getPBIEmbedToken(getReportIdForGen2(), getDatasetId());
      const tabs = getPbiUrlConfigsForSkuDetails();
      // pick the tab/report url skuDetails
      const skuDetails = tabs.find((tab) => tab.id === 'skuDetails');
      if (skuDetails) {
        setSelectedUrl(skuDetails.pbi_url);
      }
    }
  }, [openIframe]);

  const getPBIEmbedToken = async (reportId, datasetId) => {
    const embedToken = await fetchPBIEmbedToken(reportId, datasetId);
    setPbiEmbedToken(embedToken);
  };

  const getFilteredURL = (url) => {
   const trimmedBu = encodeURIComponent(selectedBu?.trim());
   return (
    `${url}&disableSensitivityBanner=true&experience=power-bi&navContentPaneEnabled=false` +
    `&filter=DimBU/BusinessUnitName eq '${trimmedBu}'`
   );
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        size="small"
        sx={{
          fontSize: '1rem',
          height: '32px',
          border: '1px solid #0056b3',
          borderRadius: '20px',
          backgroundColor: '#0056b3',
          marginTop: '18px',
          color: '#fff',
          "&:hover": {
            backgroundColor: "#115293", // darker blue
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)", // shadow on hover
          }
        }}
        onClick={() => setOpenIframe(true)}>
          SKU Details
        </Button>
      {selectedUrl && (
        <Dialog open={openIframe} onClose={() => setOpenIframe(false)} fullWidth maxWidth="lg" data-testid="sku-dialog">
          <DialogTitle sx={{ m: 0, p: 2 }}>
            <IconButton onClick={() => setOpenIframe(false)} aria-label="Close"
               sx={{ position: "absolute", right: 8, top: 8, zIndex: 10 }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ p: 0, height: "80vh" }}>
            <Stack gap="16px" sx={{ padding: '24px', width: '100%' }}>
              <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                <div className="iframe-paper-container">
                  <div className="iframe-container">
                    <div className="iframe-content">
                      <PowerBIEmbed
                        key={reportId}
                        embedConfig={getEmbedConfig(getFilteredURL(selectedUrl), pbiEmbedToken)}
                        cssClassName={'report-style-class'}
                      />
                    </div>
                  </div>
                </div>
              </Box>
            </Stack>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
export default SkuDetails;